//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

export interface IFontListItem {
  label: string;
  value: string;
}

export const DEFAULT_FONT_VALUE = `BlinkMacSystemFont, -apple-system, "Segoe UI", Helvetica, Arial, sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"
`;

export const DEFAULT_GUTTER_SIZE = 10;

export const STANDARD_FONT_LIST: IFontListItem[] = [
  {
    label: 'Default (system)',
    value: DEFAULT_FONT_VALUE,
  },
  {
    label: 'Arial',
    value: 'Arial',
  },
  {
    label: 'Helvetica',
    value: 'Helvetica',
  },
  {
    label: 'Times New Roman',
    value: 'Times New Roman',
  },
  {
    label: 'Times',
    value: 'Times',
  },
  {
    label: 'Courier New',
    value: 'Courier New',
  },
  {
    label: 'Courier',
    value: 'Courier',
  },
  {
    label: 'Verdana',
    value: 'Verdana',
  },
  {
    label: 'Georgia',
    value: 'Georgia',
  },
  {
    label: 'Palatino',
    value: 'Palatino',
  },
  {
    label: 'Garamond',
    value: 'Garamond',
  },
  {
    label: 'Bookman',
    value: 'Bookman',
  },
  {
    label: 'Trebuchet MS',
    value: 'Trebuchet MS',
  },
  {
    label: 'Impact',
    value: 'Impact',
  },
  {
    label: 'Arial Black',
    value: 'Arial Black',
  },
];
